module.exports = __webpack_public_path__ + "img/process-icon5.af3a6726.png";